import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useAuth, AuthProvider } from "../contexts/AuthProvider";
import NotFound from "../pages/404/notFounds";
import NotAuthorized from "../pages/403/not-authorized";
import Home from "../pages/home/home";
import Login from "../pages/login/login";
import EmpresasRegister from "../pages/empresasCadastro/EmpresasRegister";
import EmpresasListage from "../pages/empresasListage/EmpresasListage";
import PersonRegister from "../pages/personsRegister/personsRegister";
import { Component, useEffect } from "react";
import UniListage from "../pages/uniListage/uniListage";
import UnidadesRegister from "../pages/cadastroUnidades/CadastrosUnidades";
import ApplicationListage from "../pages/applicationsListage/applicationsListage";
import ApplicationsRegister from "../pages/applicationsRegister/ApplicationsRegister ";
import AdminListage from "../pages/adminListage/adminListage";
import PerfilListage from "../pages/perfilListage/perfilListage";
import TipoAplicacaoListage from "../pages/tipo_aplicacao_listage/tipo_aplicacao_listage";
import TipoAplicacaoRegister from "../pages/tipo_aplicacao_cadastros/tipo_aplicacao_cadastros";
import UnidadeMedidaListage from "../pages/Unidades_Medida_listage/Unidades_medida_listage";
import UnidadesMedidaRegister from "../pages/Unidades_medida_cadastro/Unidades_medida_cadastro";
import GruposMaterialListage from "../pages/Grupos_materiais_Listage/Grupos_materiais_listage";
import GruposMaterialRegister from "../pages/Grupos_material_cadastros/Grupos_material_cadastros";
import PerfilRegister from "../pages/perfilCadastro/perfilCadastros";
import MaterialListage from "../pages/produtosListage/materiaisListage";
import MaterialRegister from "../pages/cadastrosMateriais/CadastrosMateriais";
import UserRegister from "../pages/userCadastro/userCadastro";
import TipoManutencaoListage from "../pages/tiposManutencao/tiposManutencao";
import TipoManutencaoRegister from "../pages/tiposManutencaoCadastro/tiposManutencaoCadastro";
import SetoresExecutantesListage from "../pages/setoresExecutantesListage/setoresExecutantesListage";
import ServicosListage from "../pages/servicosListage/servicosListage";
import ServicosRegister from "../pages/servicosCadastros/servicosCadastros";
import ProcedimentosPlanosListage from "../pages/procedimentosPlanosListage/procedimentosPlanosListage";
import ProcedimentosPlanosRegister from "../pages/procedimentosPlanosCadastros/procedimentosPlanosCadastros";
import PlanosManutencaoListage from "../pages/planosManutencao/planosManutencaoListage";
import PlanosManutencaoRegister from "../pages/planosManutencaoCadastros/planoManutencaoCadastros";
import MaterialPlanoListage from "../pages/materiaisPlanoListage/materiaisPlanosListage";
import MateriaisPlanoRegister from "../pages/materiaisPlanosCadastro/materiaisPlanosCadastros";
import PessoasSetoresExecutantesListage from "../pages/pessoasSetoresExecutantesListage/pessoasSetoresExecutantesListage";
import PessoasSetoresExecutantesRegister from "../pages/pessoasSetoresExecutantesCadastros/pessoasSetoresExecutantesCadastros";
import PersonsListage from "../pages/personsListage/personsListage";
import SolicitacoesListage from "../pages/solicitacoesListage/SolicitacoesListage";
import SolicitacoesRegister from "../pages/solicitacoesRegister/SolicitacoesRegister";
import OrdensServicoListage from "../pages/ordensServicoListage/ordensServicoListage";
import OrdensServicoRegister from "../pages/ordensServicoCadastro/ordensServicoCadastro";
import ServicoOrdemListage from "../pages/servicosOrdemServicoListage/servicosOrdemListage";
import ServicoOrdemRegister from "../pages/servicosOrdemCadastro/servicoOrdemCadastro";
import PessoasOrdemListage from "../pages/pessoasOrdemServico/pessoasOrdemServico";
import PessoasOrdemRegister from "../pages/pessoasOrdemCadastro/pessoasOrdemCadastro";
import MaterialOrdemListage from "../pages/materiaisOrdemListage/materiaisOrdemListage";
import MateriaisOrdemRegister from "../pages/materiaisOrdemCadastro/materiaisOrdemCadastro";
import RelatorioPage from "../pages/garantiaRelatório/relatorioPage";
import Relatorio from "../components/Relatorios/relatorioGarantia";
import RelatorioInventarioCliente from "../components/Relatorios/relatorioInventario";
import InventarioPage from "../pages/relatorioInventario/inventarioPage";
import SetoresExecutantesRegister from "../pages/setoresExecutantesCadastro/setoresExecutantesCadastro";
import GerenciamentoPlanos from "../pages/gerenciamentoPlanos/GerenciamentoPlanos";
import AplicacoesPlanoListage from "../pages/aplicacoesPlanoListage/aplicacoesPlanoListage";
import AplicacoesPlanoRegister from "../pages/aplicacoesPlanoCadastro/aplicacoesPlanoCadastro";
import HistoricoPage from "../pages/historicoManutencao/historicoPage";
import Histograma from "../components/Relatorios/histogramaManutencao";
import HistogramaPage from "../pages/histogramaPage/histogramaPage";
import { PermissionsProvider, usePermissions } from "../contexts/PermissionsProvider";
import { Spinner } from "react-bootstrap";

function PrivateRoute({ element: Element, requiredPermissions = [], ...rest }) {
  const { token } = useAuth();
  const { permissions =[], loading } = usePermissions();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (!permissions || permissions.length === 0) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <Spinner />
      </div>
    );
  }

  // Verifica se o usuário possui as permissões necessárias
  const hasRequiredPermissions = requiredPermissions.every((reqPerm) =>
    permissions.some(
      (userPerm) =>
        userPerm.entidade === reqPerm.entidade &&
        reqPerm.actions.every((action) => userPerm[action] === 1)
    )
  );

  // Se o usuário não tiver as permissões necessárias, redireciona para uma página de acesso negado
  if (!hasRequiredPermissions) {
    return <Navigate to="/not-authorized" />;
  }

  // Renderiza o componente protegido
  return <Element />;
};

export default function Rotas() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PermissionsProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />


          {/* Utilize PrivateRoute diretamente nas rotas desejadas */}

          <Route path="/home"
            element={
              <PrivateRoute
                element={Home}
              >
              </PrivateRoute>
            }
          />

          <Route
            path="/aplicacoes/"
            element={
              <PrivateRoute
              element={ApplicationListage}
                requiredPermissions={[
                  { entidade: "Aplicacao", actions: ["view"] }  // Ajuste as permissões conforme necessário
                ]}
              >
              </PrivateRoute>
            }
          />
          <Route
            path="/aplicacoes-cadastrar/*"
            element={<PrivateRoute element={ApplicationsRegister} 
            requiredPermissions={[
              { entidade: "Aplicacao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}/>}
          />

          <Route
            path="/users/"
            element={<PrivateRoute element={AdminListage}
             requiredPermissions={[
              { entidade: "User", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}/>}
          />
          <Route
            path="/user-cadastrar/*"
            element={<PrivateRoute element={UserRegister}
            requiredPermissions={[
              { entidade: "User", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]} />}
          />

          <Route
            path="/perfis/"
            element={<PrivateRoute element={PerfilListage} 
            requiredPermissions={[
              { entidade: "Perfil", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/perfil-cadastrar/*"
            element={<PrivateRoute element={PerfilRegister} 
            requiredPermissions={[
              { entidade: "Perfil", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/empresas/"
            element={<PrivateRoute element={EmpresasListage} 
            requiredPermissions={[
              { entidade: "Empresa", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/empresa-cadastrar/*"
            element={<PrivateRoute element={EmpresasRegister} 
            requiredPermissions={[
              { entidade: "Empresa", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/grupos-material/"
            element={<PrivateRoute element={GruposMaterialListage} 
            requiredPermissions={[
              { entidade: "GrupoMaterial", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/grupo-material-cadastrar/*"
            element={<PrivateRoute element={GruposMaterialRegister} 
            requiredPermissions={[
              { entidade: "GrupoMaterial", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/materiais/"
            element={<PrivateRoute element={MaterialListage} 
            requiredPermissions={[
              { entidade: "Material", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/material-cadastrar/*"
            element={<PrivateRoute element={MaterialRegister} 
            requiredPermissions={[
              { entidade: "Material", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/pessoas/"
            element={<PrivateRoute element={PersonsListage} 
            requiredPermissions={[
              { entidade: "Pessoa", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/pessoa-cadastrar/*"
            element={<PrivateRoute element={PersonRegister} 
            requiredPermissions={[
              { entidade: "Pessoa", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/servicos/"
            element={<PrivateRoute element={ServicosListage} 
            requiredPermissions={[
              { entidade: "Servicos", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/servico-cadastrar/*"
            element={<PrivateRoute element={ServicosRegister} 
            requiredPermissions={[
              { entidade: "Servicos", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/setores-executantes/"
            element={<PrivateRoute element={SetoresExecutantesListage} 
            requiredPermissions={[
              { entidade: "SetoresExecutantes", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/setor-executante-cadastrar/*"
            element={<PrivateRoute element={SetoresExecutantesRegister} 
            requiredPermissions={[
              { entidade: "SetoresExecutantes", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/pessoas-setor-executante/"
            element={
              <PrivateRoute element={PessoasSetoresExecutantesListage} 
              requiredPermissions={[
                { entidade: "PessoaSetorExecutante", actions: ["view"] }  // Ajuste as permissões conforme necessário
              ]}
              />
            }
          />
          <Route
            path="/pessoa-setor-executante-cadastrar/*"
            element={
              <PrivateRoute element={PessoasSetoresExecutantesRegister} 
              requiredPermissions={[
                { entidade: "PessoaSetorExecutante", actions: ["view"] }  // Ajuste as permissões conforme necessário
              ]}
              />
            }
          />

          <Route
            path="/tipos-aplicacao/"
            element={<PrivateRoute element={TipoAplicacaoListage} 
            requiredPermissions={[
              { entidade: "TiposAplicacao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/tipo-aplicacao-cadastrar/*"
            element={<PrivateRoute element={TipoAplicacaoRegister} 
            requiredPermissions={[
              { entidade: "TiposAplicacao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/tipos-manutencao/"
            element={<PrivateRoute element={TipoManutencaoListage} 
            requiredPermissions={[
              { entidade: "TipoManutencao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/tipo-manutencao-cadastrar/*"
            element={<PrivateRoute element={TipoManutencaoRegister} 
            requiredPermissions={[
              { entidade: "TipoManutencao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/unidades/"
            element={<PrivateRoute element={UniListage} 
            requiredPermissions={[
              { entidade: "Unidade", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/unidade-cadastrar/*"
            element={<PrivateRoute element={UnidadesRegister} 
            requiredPermissions={[
              { entidade: "Unidade", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/unidades-medida/"
            element={<PrivateRoute element={UnidadeMedidaListage} 
            requiredPermissions={[
              { entidade: "UnidadeMedida", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/unidade-medida-cadastrar/*"
            element={<PrivateRoute element={UnidadesMedidaRegister} 
            requiredPermissions={[
              { entidade: "UnidadeMedida", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/gerenciamento-planos/"
            element={<PrivateRoute element={GerenciamentoPlanos} 
            requiredPermissions={[
              { entidade: "AplicacaoPlanoManutencao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/ordens-servico/"
            element={<PrivateRoute element={OrdensServicoListage} 
            requiredPermissions={[
              { entidade: "OrdensServico", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/ordem-servico-cadastrar/*"
            element={<PrivateRoute element={OrdensServicoRegister} 
            requiredPermissions={[
              { entidade: "OrdensServico", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/execucao/"
            element={<PrivateRoute element={ServicoOrdemListage} 
            requiredPermissions={[
              { entidade: "ServicosOrdem", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/execucao-cadastrar/*"
            element={<PrivateRoute element={ServicoOrdemRegister} 
            requiredPermissions={[
              { entidade: "ServicosOrdem", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/pessoas-ordem/"
            element={<PrivateRoute element={PessoasOrdemListage} 
            requiredPermissions={[
              { entidade: "PessoaServicoOrdem", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/pessoa-ordem-cadastrar/*"
            element={<PrivateRoute element={PessoasOrdemRegister} 
            requiredPermissions={[
              { entidade: "PessoaServicoOrdem", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/materiais-servico/"
            element={<PrivateRoute element={MaterialOrdemListage} 
            requiredPermissions={[
              { entidade: "MateriaisServico", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/material-servico-cadastrar/*"
            element={<PrivateRoute element={MateriaisOrdemRegister} 
            requiredPermissions={[
              { entidade: "MateriaisServico", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/planos-manutencao/"
            element={<PrivateRoute element={PlanosManutencaoListage} 
            requiredPermissions={[
              { entidade: "PlanosManutencao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/plano-manutencao-cadastrar/*"
            element={<PrivateRoute element={PlanosManutencaoRegister} 
            requiredPermissions={[
              { entidade: "PlanosManutencao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/procedimentos-plano/"
            element={<PrivateRoute element={ProcedimentosPlanosListage} 
            requiredPermissions={[
              { entidade: "ProcedimentosPlano", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/procedimento-plano-cadastrar/*"
            element={<PrivateRoute element={ProcedimentosPlanosRegister} 
            requiredPermissions={[
              { entidade: "ProcedimentosPlano", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/aplicacoes-plano/*"
            element={<PrivateRoute element={AplicacoesPlanoListage} 
            requiredPermissions={[
              { entidade: "AplicacaoPlanoManutencao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/aplicacao-plano-cadastrar/*"
            element={<PrivateRoute element={AplicacoesPlanoRegister} 
            requiredPermissions={[
              { entidade: "AplicacaoPlanoManutencao", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/materiais-plano/"
            element={<PrivateRoute element={MaterialPlanoListage} 
            requiredPermissions={[
              { entidade: "MaterialPlano", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/material-plano-cadastrar/*"
            element={<PrivateRoute element={MateriaisPlanoRegister} 
            requiredPermissions={[
              { entidade: "MaterialPlano", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/solicitacoes-servico/"
            element={<PrivateRoute element={SolicitacoesListage} 
            requiredPermissions={[
              { entidade: "SolicitacaoServico", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/solicitacao-servico-cadastrar/*"
            element={<PrivateRoute element={SolicitacoesRegister} 
            requiredPermissions={[
              { entidade: "SolicitacaoServico", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />

          <Route
            path="/aplicacao_garantia/"
            element={<PrivateRoute element={RelatorioPage} 
            requiredPermissions={[
              { entidade: "AplicGarServ", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/inventario_clientes"
            element={<PrivateRoute element={InventarioPage} 
            requiredPermissions={[
              { entidade: "InvCliSv", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/historico_manutencao"
            element={<PrivateRoute element={HistoricoPage} 
            requiredPermissions={[
              { entidade: "HistogrServ", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route
            path="/histograma_manutencoes_corretivas"
            element={<PrivateRoute element={HistogramaPage} 
            requiredPermissions={[
              { entidade: "HistManServ", actions: ["view"] }  // Ajuste as permissões conforme necessário
            ]}
            />}
          />
          <Route path="*" element={<PrivateRoute element={NotFound}/>} />
          <Route path="/not-authorized" element={<PrivateRoute element={NotAuthorized}/>}/>
        </Routes>
        </PermissionsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
